module.exports = __webpack_public_path__ + "static/media/RatTrance.82457d47.mp3";